import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import { userRetentionByModule } from "../apiConfigs"

export const UserRetentionByModuleApi = createAsyncThunk(
    'auth/analytics/UserRetentionByModuleApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(userRetentionByModule, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const UserRetentionByModuleSlice = createSlice({
    name: 'analytics/UserRetentionByModuleApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(UserRetentionByModuleApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(UserRetentionByModuleApi.fulfilled, (state, action) => {
            console.log("action.payload in slice", action?.payload?.result);
            state.loading = false
            state.result = action?.payload?.result?.results
            state.message = action?.payload?.message
            state.total = action?.payload?.result?.total_pages
        })
        builder.addCase(UserRetentionByModuleApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const UserRetentionByModuleReducer = UserRetentionByModuleSlice.reducer